module.exports = __webpack_public_path__ + "img/upload-email-generic-en.db0839ac.png";